




































































































































































































































import ModalCreatePassCode from "@/components/modal/PassCode/ModalCreatePassCode.vue";
import ModalRemovePassCode from "@/components/modal/PassCode/ModalRemovePassCode.vue";
import ModalResetPassCode from "@/components/modal/PassCode/ModalResetPassCode.vue";
import ModalViewPassCode from "@/components/modal/PassCode/ModalViewPassCode.vue";
import {
  BillingNoteDatabaseStatus,
  ContactEnvelopePageSizeType,
  CurrencyCode,
  DebitNoteDatabaseStatus,
  DocumentTourStatus,
  DocumentType,
  FinanceType,
  InvoiceDatabaseStatus,
  LoadingStatusType,
  Package,
  QRPaymentType,
  TaxSourceType,
  TransactionType,
} from "@/enums/enums";
import { GetPaperSizeName } from "@/helper/contactEnvelopeHelper";
import { CheckMerchantPackage } from "@/helper/userHelper";
import {
  DocumentGeneratePdfModel,
  DocumentSaveSettingOptionModel,
  InputDoSetSetttingDefaultModel,
  OnlineViewModel,
} from "@/model/document/documentModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { PP30OnlineViewModel } from "@/model/document/pp30DocumentModel";
import { WitholdingTaxOnlineViewModel } from "@/model/document/witholdingTaxDocumentModal";
import { MerchantModel } from "@/model/merchant/merchantModel";
import { GetTransactionRemainPaymentModel } from "@/model/payment/paymentModel";
import { UserModel } from "@/model/user/userModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { analytics, event } from "../../service/analytics/analytics";

import { CheckIsCustomizeDocument } from "@/helper/documentHelper";
import SelectDocumentType from "./SelectDocumentType.vue";

const StoreAuthentication = namespace("Authentication");
const StoreDocument = namespace("Document");
const StorePayment = namespace("Payment");
const StoreMerchant = namespace("Merchant");
const StoreGeneratePdf = namespace("GeneratePdf");

@Component({
  components: {
    ModalViewPassCode,
    ModalResetPassCode,
    ModalRemovePassCode,
    ModalCreatePassCode,
    SelectDocumentType,
  },
})
export default class MainNavBar extends Vue {
  @Prop({}) merchantDetail!: MerchantModel;
  @Prop({ default: false }) isAuthorized!: boolean;
  @Prop({ default: false }) isCanNotOpenDocument!: boolean;
  @Prop({ default: "" }) documentName!: string;
  @Prop({ default: 0 }) transactionNumber!: string;
  @Prop({ default: 0 }) sourceType!: number;
  @Prop({ default: false }) isDocumentNameShort!: boolean;

  private isShowModalViewPassCode: boolean = false;
  private isShowModalResetPassCode: boolean = false;
  private isShowModalRemovePassCode: boolean = false;
  private isShowModalCreatePassCode: boolean = false;
  private isShowMakePayment: boolean = false;
  private isValidatePackage = CheckMerchantPackage([Package.Free, Package.Basic, Package.Pro]);
  private isShowDocumentTourEdit = false;
  private isCustomize = CheckIsCustomizeDocument();

  private TaxSourceType = TaxSourceType;
  private TransactionType = TransactionType;
  private DocumentType = DocumentType;
  private DocumentTourStatus = DocumentTourStatus;

  @StoreAuthentication.Getter
  private getUserInfo!: UserModel | null;
  @StoreDocument.Getter
  private getDocumentLoadingStatus!: LoadingStatusType;
  @StoreDocument.Getter
  private getDocumentDetail!:
    | OnlineViewModel
    | JournalOnlineViewModel
    | PP30OnlineViewModel
    | WitholdingTaxOnlineViewModel
    | null;
  @StoreDocument.Getter
  private getIsEditMode!: boolean;
  @StoreDocument.Getter
  private getCustomizeIdList!: Array<any>;
  @StorePayment.Getter
  private getTransactionRemainPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getTransactionRemainPaymentModel!: any;
  @StoreMerchant.Getter
  private getMerchantQRPaymentModel!: any;

  @StoreDocument.Action
  private DoSetIsEditMode!: (isEditMode: boolean) => void;
  @StoreDocument.Action
  private DoSetDefaultDocument!: (setDefaultDocument: boolean) => void;
  @StoreDocument.Action
  private DoSetIsSaveSettingOption!: (isSaveSettingOption: DocumentSaveSettingOptionModel | null) => void;
  @StoreDocument.Action
  private DoGetSettingDefault!: (input: InputDoSetSetttingDefaultModel) => void;
  @StorePayment.Action
  private DoGetTransactionRemainPayment!: (input: GetTransactionRemainPaymentModel) => void;
  @StoreMerchant.Action
  private DoGetQRPaymentSetting!: () => void;
  @StoreGeneratePdf.Action
  private DoGeneratePdfLogService!: (input: DocumentGeneratePdfModel) => void;

  created() {
    this.GetQRPaymentSetting();

    if (this.getTransactionRemainPaymentLoadingStatus === LoadingStatusType.Success) {
      this.SetIsShowMakePayment();
    }
  }

  get documentLoaingStatus() {
    return this.getDocumentLoadingStatus === LoadingStatusType.Success;
  }

  get isSettingWithPassCode() {
    return this.getDocumentDetail?.credential.passCode !== "";
  }

  get isCanClickLink() {
    let isWhtTaxCanClickLink = true;
    if (this.getDocumentDetail?.transactionType == TransactionType.WithholdingTax) {
      let urlEsti: any = this.$route.query.esti;
      const sourceType = urlEsti ? urlEsti.PeakDecryption() : 0;
      if (sourceType !== TaxSourceType.PeakTax) {
        isWhtTaxCanClickLink = false;
      }
    }
    return this.getUserInfo && isWhtTaxCanClickLink;
  }

  get isEnvelope() {
    return this.getDocumentDetail?.transactionType === DocumentType.Envelope;
  }

  get isDocumentOtherType() {
    return (
      this.getDocumentDetail?.transactionType === DocumentType.Envelope ||
      this.getDocumentDetail?.transactionType === DocumentType.ExecutiveSummary
    );
  }

  get isValidateQRPayment() {
    return this.getMerchantQRPaymentModel && this.getMerchantQRPaymentModel.qrPaymentTypeId > QRPaymentType.Bank;
  }

  get isCanPayment() {
    if (
      this.getDocumentDetail instanceof OnlineViewModel &&
      !this.getIsEditMode &&
      this.getTransactionRemainPaymentModel &&
      this.CheckOpenBtnPaidPayment(this.getDocumentDetail)
    ) {
      if (this.getDocumentDetail.document.data.isDeleted) {
        return false;
      } else if (this.isValidateQRPayment && this.isValidatePackage) {
        return false;
      }
      return true;
    }
    return false;
  }

  get isShowDocumentName() {
    let isShowDocumentName = true;
    if (this.getCustomizeIdList && this.getCustomizeIdList.length > 0) {
      isShowDocumentName = false;
    }
    return isShowDocumentName;
  }

  @Watch("$route", { immediate: true })
  routeChanged(newVal: any) {
    if (newVal.name) {
      this.CheckDocumentTour(newVal.name);
    }
  }

  @Watch("getDocumentLoadingStatus")
  getDocumentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.isShowMakePayment = false;
      this.SetBeforeGetTransactionRemainPayment();
    }
  }

  @Watch("getTransactionRemainPaymentLoadingStatus")
  getTransactionRemainPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      this.SetIsShowMakePayment();
    } else if (newVal === LoadingStatusType.None) {
      this.SetBeforeGetTransactionRemainPayment();
    }
  }

  public CheckDocumentTour(routerName: string) {
    if (routerName === "receipt") {
      let query = Object.assign({}, this.$route.query);
      this.isShowDocumentTourEdit = query.tourEdit === DocumentTourStatus.Show.toString();
    }
  }

  public SetBeforeGetTransactionRemainPayment() {
    if (
      (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
        this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
        this.getDocumentDetail?.transactionType == TransactionType.BillingNote) &&
      this.getDocumentDetail?.financeType === FinanceType.InFlow &&
      this.getDocumentDetail?.transactionId > 0 &&
      this.merchantDetail.isQrPayment
    ) {
      this.GetTransactionRemainPayment(this.getDocumentDetail?.transactionId, this.getDocumentDetail?.transactionType);
    }
  }

  public CheckOpenBtnPaidPayment(getDocumentDetail: OnlineViewModel) {
    let isCanGetData = false;

    if (
      getDocumentDetail != null &&
      getDocumentDetail.financeType == FinanceType.InFlow &&
      getDocumentDetail.transactionId > 0
    ) {
      const transactionType: number = getDocumentDetail.transactionType;
      const statusType: number = getDocumentDetail?.document.data.statusType;
      if (transactionType == TransactionType.Invoice && statusType >= InvoiceDatabaseStatus.OutstandingOrOverdue) {
        isCanGetData = true;
      } else if (transactionType == TransactionType.DebitNote && statusType >= DebitNoteDatabaseStatus.Approved) {
        isCanGetData = true;
      } else if (
        transactionType == TransactionType.BillingNote &&
        statusType >= BillingNoteDatabaseStatus.OutstandingOrOverdue
      ) {
        isCanGetData = true;
      }
    }

    return isCanGetData;
  }

  public GetQRPaymentSetting() {
    this.DoGetQRPaymentSetting();
  }

  public SetIsShowMakePayment() {
    if (
      (this.getDocumentDetail?.transactionType == TransactionType.Invoice ||
        this.getDocumentDetail?.transactionType == TransactionType.DebitNote ||
        this.getDocumentDetail?.transactionType == TransactionType.BillingNote) &&
      this.getDocumentDetail?.financeType === FinanceType.InFlow &&
      this.merchantDetail.isQrPayment
    ) {
      let paidTotal = this.getTransactionRemainPaymentModel.netAmount - this.getTransactionRemainPaymentModel.paidTotal;
      if (paidTotal > 0) {
        this.isShowMakePayment = true;
      } else {
        this.isShowMakePayment = false;
      }
    }
  }

  public GetSettingDefault() {
    const input: InputDoSetSetttingDefaultModel = {
      transactionType: this.getDocumentDetail?.transactionType ?? 0,
      financeType: this.getDocumentDetail?.financeType ?? 0,
      expenseType: this.getDocumentDetail?.expenseType ?? 0,
      headerOptionType: this.getDocumentDetail?.headerOptionType ?? 0,
      toCurrency:
        this.getDocumentDetail instanceof OnlineViewModel
          ? this.getDocumentDetail.document.data.currency.toCurrency.currencyCode
          : CurrencyCode.THB,
    };
    this.DoGetSettingDefault(input);
  }

  public GetPaperSizeName(pageSize: ContactEnvelopePageSizeType) {
    return GetPaperSizeName(pageSize);
  }
  public GeneratePdfLogService() {
    let input: DocumentGeneratePdfModel = {
      transactionNumber: this.transactionNumber,
      documentName: this.documentName,
      isDocumentNameShort: this.isDocumentNameShort,
      passCode: "",
      transactionType: this.getDocumentDetail?.transactionType || TransactionType.None,
    };
    this.DoGeneratePdfLogService(input);
  }
  public PrintDocument() {
    this.GeneratePdfLogService();
    window.print();
  }
  public DoSetIsSaveSetting(isSaveMainSetting: boolean) {
    let saveSettingOption: DocumentSaveSettingOptionModel = {
      isSaveSetting: true,
      isSaveMainSetting: isSaveMainSetting,
    };
    this.DoSetIsSaveSettingOption(saveSettingOption);
  }

  public GetTransactionRemainPayment(
    transactionId: number,
    transactionType: TransactionType,
    isConfirmPayment = false
  ) {
    let input = {
      transactionId: transactionId,
      transactionType: transactionType,
      isConfirmPayment: isConfirmPayment,
    };
    this.DoGetTransactionRemainPayment(input);
  }
  public CheckDocumentTourEdit(mode: string) {
    let query = Object.assign({}, this.$route.query);
    if (this.$route.name === "receipt" && query.tourEdit) {
      if (mode === DocumentTourStatus.Edit.toString()) {
        this.mixpanelEvent("onlineview_edit_tour_document");
      }
      this.$router.replace({ name: "receipt", query: { ...this.$route.query, tourEdit: mode } }).catch(() => {});
    }
  }

  public mixpanelEvent(menu: string) {
    const mixpanelEvent: any = event;
    analytics.emitEvent(mixpanelEvent.in_app[menu], { language: this.$i18n.locale });
  }
}
